import * as moment from 'moment'
import { IMap, IProviderProductObject, IProviderProductState, IStoreState } from '../../../types'
import { IProviderProductAction } from '../../actions/provider-products'
import * as constants from '../../constants'

const initState: IProviderProductState = {
  isFetching: false,
  items: {},
  currentProductIds: [],
  lastUpdated: Date.now(),
  error: '',
  query: '',
  deleteProductModal: {
    show: false,
    deleting: false,
    error: ''
  },
  activateProductModal: {
    show: false,
    activating: false,
    error: ''
  },
  deactivateProductModal: {
    show: false,
    deactivating: false,
    error: ''
  },
  filters: {},
  productCount: 0
}

export function providerProduct(
  state: IProviderProductState = initState,
  action: IProviderProductAction
): IProviderProductState {
  switch (action.type) {
    case constants.PRODUCT_FILTER:
      return { ...state, query: action.payload }
    case constants.SET_CURRENT_PRODUCT_IDS: {
      return { ...state, currentProductIds: action.payload }
    }
    case constants.PRODUCT_FETCH_REQUEST: {
      return { ...state, isFetching: true }
    }
    case constants.PRODUCT_FETCH_SUCCESS: {
      const product = action.payload
      const items = { ...state.items }
      items[product.id] = product
      return {
        ...state,
        items
      }
    }
    case constants.PRODUCT_FETCH_FAIL: {
      return {
        ...state,
        error: action.payload,
        isFetching: false
      }
    }
    case constants.PROVIDER_PRODUCT_SAVE_SUCCESS: {
      const product = action.payload
      state.items[product.id] = product
      return Object.assign({}, state, {
        lastUpdated: Date.now()
      })
    }
    case constants.PROVIDER_PRODUCT_CREATE_SUCCESS: {
      const product = action.payload
      state.items[product.id] = product
      return Object.assign({}, state, {
        lastUpdated: Date.now()
      })
    }
    //TODO figure out what this is
    case constants.PROVIDER_PRODUCT_REMOVE_REQUEST: {
      return Object.assign({}, state, {
        deleteProductModal: {
          ...state.deleteProductModal,
          deleting: true
        }
      })
    }
    case constants.PROVIDER_PRODUCT_REMOVE_SUCCESS: {
      const product = action.payload
      delete state.items[product.id]
      return Object.assign({}, state, {
        lastUpdated: Date.now(),
        deleteProductModal: {
          ...state.deleteProductModal,
          deleting: false,
          error: '',
          show: false
        }
      })
    }
    case constants.PROVIDER_PRODUCT_REMOVE_FAIL: {
      return Object.assign({}, state, {
        lastUpdated: Date.now(),
        deleteProductModal: {
          ...state.deleteProductModal,
          deleting: false,
          error: action.payload
        }
      })
    }
    case constants.PROVIDER_PRODUCT_ACTIVATE_REQUEST: {
      return Object.assign({}, state, {
        activateProductModal: {
          ...state.activateProductModal,
          activating: true
        }
      })
    }
    case constants.PROVIDER_PRODUCT_ACTIVATE_SUCCESS: {
      const product = action.payload
      const itemToActivate = state.items[product.id]
      const activatedItem = Object.assign({}, itemToActivate, product, {
        modified: true
      })
      state.items[product.id] = activatedItem

      return Object.assign({}, state, {
        lastUpdated: Date.now(),
        activateProductModal: {
          ...state.activateProductModal,
          activating: false,
          error: '',
          show: false
        }
      })
    }
    case constants.PROVIDER_PRODUCT_ACTIVATE_FAIL: {
      return Object.assign({}, state, {
        lastUpdated: Date.now(),
        activateProductModal: {
          ...state.activateProductModal,
          activating: false,
          error: action.payload
        }
      })
    }
    case constants.PROVIDER_PRODUCT_DEACTIVATE_REQUEST: {
      return Object.assign({}, state, {
        deactivateProductModal: {
          ...state.deactivateProductModal,
          deactivating: true
        }
      })
    }
    case constants.PROVIDER_PRODUCT_DEACTIVATE_SUCCESS: {
      const product = action.payload
      const itemToDeactivate = state.items[product.id]
      const deactivatedItem = Object.assign({}, itemToDeactivate, product, {
        modified: true
      })
      state.items[product.id] = deactivatedItem

      return Object.assign({}, state, {
        lastUpdated: Date.now(),
        deactivateProductModal: {
          ...state.deactivateProductModal,
          deactivating: false,
          error: '',
          show: false
        }
      })
    }
    case constants.PROVIDER_PRODUCT_DEACTIVATE_FAIL: {
      return Object.assign({}, state, {
        lastUpdated: Date.now(),
        deactivateProductModal: {
          ...state.deactivateProductModal,
          deactivating: false,
          error: action.payload
        }
      })
    }
    case constants.PROVIDER_PRODUCT_LIST_SUCCESS: {
      return Object.assign({}, state, {
        items: { ...action.payload }
      })
    }
    case constants.PROVIDER_PRODUCT_LIST_SUCCESS_COUNT: {
      return Object.assign({}, state, {
        productCount: action.payload
      })
    }
    case constants.PROVIDER_PRODUCT_LIST_FAIL: {
      return Object.assign({}, state, {
        isFetching: false
      })
    }
    case constants.PROVIDER_PRODUCT_ACTIVATE_MODAL_SHOW: {
      return Object.assign({}, state, {
        activateProductModal: {
          show: true,
          activating: false,
          error: '',
          product: action.payload
        }
      })
    }
    case constants.PROVIDER_PRODUCT_ACTIVATE_MODAL_HIDE: {
      return Object.assign({}, state, {
        activateProductModal: {
          show: false,
          activating: false,
          error: ''
        }
      })
    }
    case constants.PROVIDER_PRODUCT_DEACTIVATE_MODAL_SHOW: {
      return Object.assign({}, state, {
        deactivateProductModal: {
          show: true,
          processing: false,
          error: '',
          product: action.payload,
          productId: action.payload.id
        }
      })
    }
    case constants.PROVIDER_PRODUCT_DEACTIVATE_MODAL_HIDE: {
      return Object.assign({}, state, {
        deactivateProductModal: {
          show: false,
          processing: false,
          error: ''
        }
      })
    }
    case constants.PROVIDER_PRODUCT_DELETE_MODAL_SHOW: {
      return Object.assign({}, state, {
        deleteProductModal: {
          show: true,
          deleting: false,
          error: '',
          product: action.payload
        }
      })
    }
    case constants.PROVIDER_PRODUCT_DELETE_MODAL_HIDE: {
      return Object.assign({}, state, {
        deleteProductModal: {
          show: false,
          deleting: false,
          error: ''
        }
      })
    }
    case constants.UPDATE_PRODUCT_FILTERS: {
      return Object.assign({}, state, {
        filters: { ...state.filters, ...action.payload }
      })
    }
    case constants.PROVIDER_PRODUCT_UPDATE: {
      const product = action.payload
      const itemToUpdate = state.items[product.id]
      const updatedItem = Object.assign({}, itemToUpdate, product, {
        modified: true
      })
      state.items[product.id] = updatedItem
    }
    default:
      return state
  }
}

export const getProductsIdsByServiceId = (state: IStoreState, serviceId?: string): string[] => {
  if (!serviceId || !state.service.items[serviceId]) {
    return []
  }

  const products = state.service.items[serviceId].providerProducts
  return products ? products.map(p => p.id) : []
}

export const getProviderProducts = (providerProductState: IProviderProductState): IMap<IProviderProductObject> =>
  providerProductState.items

export const getServicesProducts = (state: IStoreState, serviceId: string): IProviderProductObject[] | undefined => {
  const service = state.service.items[serviceId]
  if (!service) {
    return
  }
  const products = service.providerProducts
  if (!products) {
    return []
  }

  return products.map(it => state.providerProduct.items[it.id]).filter(it => !!it)
}



// WEBPACK FOOTER //
// ./src/state/reducers/provider-products/index.ts